import { render } from "./DeletedInfo.vue?vue&type=template&id=72925859"
import script from "./DeletedInfo.vue?vue&type=script&lang=js"
export * from "./DeletedInfo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/putriamalia/Sites/ISR/isr-app-v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__